import React from "react";
import { Link } from "react-router-dom";
import { Package } from "lucide-react";

const options = [
  { title: "25 kg PP Bags", desc: "Standard export packaging with liner options." },
  { title: "50 kg PP Bags", desc: "Bulk milling-grade export packaging." },
  { title: "Non-Woven / Jute", desc: "Premium and traditional packaging options." },
  { title: "Private Label", desc: "Custom brand packaging subject to buyer specification." },
  { title: "10 / 20 kg Consumer Packs", desc: "Retail-ready pack sizes for select products." },
  { title: "Bulk / Break-Bulk", desc: "Container-loaded loose stuffing where applicable." },
];

const Packaging = () => (
  <div>
    <section className="bg-[#004225] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-[11px] font-eyebrow text-[#D4AF37]"><span className="gold-line mr-3" />Packaging</div>
        <h1 className="mt-2 font-display text-4xl sm:text-5xl">Export-Ready Packaging</h1>
        <p className="mt-3 max-w-2xl text-white/80">Consistent, moisture-sealed packaging designed for long-haul international transit. Private-label available subject to buyer specification.</p>
      </div>
    </section>
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {options.map((o) => (
          <div key={o.title} className="bg-white border border-[#004225]/10 rounded-sm p-6 card-elevate">
            <Package className="h-5 w-5 text-[#D4AF37]" />
            <div className="mt-3 font-display text-lg text-[#004225]">{o.title}</div>
            <p className="mt-2 text-[13px] text-[#171717]/75">{o.desc}</p>
          </div>
        ))}
      </div>
      <div className="mt-10 bg-[#004225] text-white rounded-sm p-8">
        <h3 className="font-display text-2xl">Discuss Packaging Requirements</h3>
        <p className="mt-2 text-white/80 text-[14px]">Share your target pack size, private-label artwork requirements and destination market — we will confirm feasibility and lead-time.</p>
        <div className="mt-4"><Link to="/request-quote" className="rounded-full btn-gold px-5 py-2.5 text-[11px] font-semibold uppercase tracking-widest">Request Packaging Discussion</Link></div>
      </div>
    </section>
  </div>
);

export default Packaging;
